<template>
    
    <v-card  class="overview pb-80" elevation=0 >

        <v-system-bar
                flat
                color="transparent"
                fixed
                height="40"
                class="pt-3"
            >
      
      
                
      
                <v-btn href="health" fab small color="primary" >
                    <v-icon class="white--text ">mdi-arrow-left</v-icon>
                </v-btn>
      
            </v-system-bar>

        <v-card-title class="pa-0">

             <v-img  :src="bannerImg" aspect-ratio="1" class="lighten-2 " max-height="287">
                 <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                                <v-col cols="12" md="12" sm="12" class="text-center white--text">
                                    
                                   <div >
                                       <h2 class="heading" >EMERGENCY</h2>
                                       <span class="subtitle-1 pl-3 pr-3">JUST TAP TO CALL</span>
                                   </div>
                                </v-col>
                                
                            </v-row>
             </v-img>

        </v-card-title>

        <v-card-text>
            
            <v-card class="top-card mt-50" >
                    <v-row class="pl-3 ">
                        <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                            
                            <v-img :src="tapImg" width="54" height="54"></v-img>
                           
                        </v-col>
                        <v-col cols="6" md="6" sm="6" class="d-flex align-center">
                            <div class="tap-text">TAP TO CALL<br>
                                
                            </div>
                            
                        </v-col>

                        <v-col cols="3" md="3" sm="3">
                            <v-img :src="tapImg" width="54" height="54"></v-img>
                        </v-col>
                    </v-row>
            </v-card>

            

            <v-card class="mt-3">
                <a href="tel:112">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="carImg" width="38" height="38"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                            <div class="emg-text">POLICE - <span class="nub">112</span>
                            </div>
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

            <v-card class="mt-3">
                <a href="tel:061">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="pharmecyImg" width="43" height="40"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                        <div class="emg-text">PARAMEDICS - <span class="nub">061</span><br>
                            <div class="emg-call-text">Emergency Calls Only</div>
                        </div>
                        
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

            <v-card class="mt-3">
                <a href="tel:080">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="fireImg" width="46" height="34"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                        <div class="emg-text">FIRE & RESUCE - <span class="nub">080</span><br>
                            <div class="emg-call-text">Emergency Calls Only</div>
                        </div>
                        
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

            <v-card class="mt-3 ">
                <a href="tel:080">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="forestfireImg" width="49" height="49"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                        <div class="emg-text">FOREST FIRE - <span class="nub">080</span><br>
                            <div class="emg-call-text">Emergency Calls Only</div>
                        </div>
                        
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

           

            <v-card class="mt-3">
                <a href="tel:112">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="allImg" width="38" height="39"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                        <div class="emg-text">ALL SERVICES - <span class="nub">112</span><br>
                            <div class="emg-call-text">Emergency Calls Only</div>
                        </div>
                        
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

            <v-card class="mt-3">
                <a href="tel:900 202 202">
                <v-row class="pl-3 pr-3">
                    <v-col cols="3" md="3" sm="3" class="" align="center" justify="center" >
                       
                        <v-img :src="lifeImg" width="38" height="39"></v-img>
                            
                    </v-col>
                    <v-col cols="7" md="7" sm="7" class="d-flex align-center">
                        <div class="emg-text">COAST GUARD<br>
                            <div class="coast-call-text">900 202 202</div>
                        </div>
                        
                            
                    </v-col>

                    <v-col cols="2" md="2" sm="2" class="">
                        <v-img :src="tabredImg" width="42" height="42"></v-img>
                    </v-col>

                </v-row>
                </a>
            </v-card>

        </v-card-text>

    </v-card>
</template>
<script >
import Vue from 'vue'
export default {
     props: ['business','tag']  ,

  data: () => ({
    bannerImg:require('@/assets/emergency-back.png'),
    emrImg:require('@/assets/emergency.png'),
    tapImg:require('@/assets/tap-white.png'),
    lifeImg:require('@/assets/lifeboat.png'),
    allImg:require('@/assets/all.png'),
    forestfireImg:require('@/assets/forest-fire.png'),
    fireImg:require('@/assets/fire.png'),
    pharmecyImg:require('@/assets/pharmecyCar.png'),

    tabredImg:require('@/assets/tap-red.png'),
    carImg:require('@/assets/car.png'),
    }),
  methods: 
   {
       emergency()
       {
           this.$router.push({name:'emergency'});
           this.activeBtn=0;
       }
   }
}
</script>
<style>
.pr-10
{
    padding-right: 10px !important;
}
.top-card.theme--light.v-card
{
    background: #D80027 !important;
}
.tap-text{
    color: #fff;
    font-size: 22px;
    font-weight: bold;
}
.nub{
    color:#FF0000;
    font-weight: bold;
}
.emg-text{
    color:#000;
    font-size:16px;
}
.emg-call-text{
    color: #e8e8e8;
    font-size: 14px;
    
}
.coast-call-text{
    color: #FF0000;
    font-size: 14px;
    font-weight: bold;
}
.icon-back
{
    background: rgba(237, 240, 242, 0.5);
}
.pa-10{
    padding: 10px;
}
</style>